module.exports = __webpack_public_path__ + "static/media/questionnaire-step1-mobile.3746a8c9.png";